<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    // _isMobile() {
    //   this.isMob = navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   );
    // },
  },
  mounted() {
    // this._isMobile();
  },
};
</script>

<style lang="less">
@import "./style/global";
</style>
